const cardsPerRowClasses = [
  'cui-one-up',
  'cui-two-up',
  'cui-three-up',
  'cui-four-up',
];

const fullRowCardClasses = [
  'ai-inventory-placement-container',
  'cui-c-banner',
  'cui-c-brand-prop',
  'cui-c-compound',
  'cui-breadcrumbs',
  'cui-c-notification',
  'pull-rapi-params-json',
];

module.exports = function arrangeCards(parentElement) {
  const arrangedCards = [];
  let fullRowCardsQueue = [];

  if (!parentElement) {
    return;
  }

  // find cards per row
  const parentElementCardsPerRowClass = cardsPerRowClasses.findIndex(
    cardsPerRowClass => parentElement.classList.contains(cardsPerRowClass)
  );
  const cardsPerRow =
    parentElementCardsPerRowClass !== -1
      ? parentElementCardsPerRowClass + 1
      : 4;

  let currentCardRowPosition = 1;
  Array.from(parentElement.children).forEach(childElement => {
    if (currentCardRowPosition === 1) {
      fullRowCardsQueue.forEach(largeCardQueueElement =>
        arrangedCards.push(largeCardQueueElement)
      );
      fullRowCardsQueue = [];
    }

    const isFullRowCard =
      fullRowCardClasses.findIndex(largeCardClass =>
        childElement.classList.contains(largeCardClass)
      ) !== -1;

    if (!isFullRowCard) {
      arrangedCards.push(childElement);

      if (currentCardRowPosition === cardsPerRow) {
        currentCardRowPosition = 1;
      } else {
        currentCardRowPosition++;
      }
    } else {
      fullRowCardsQueue.push(childElement);
    }
  });

  fullRowCardsQueue.forEach(largeCardQueueElement =>
    arrangedCards.push(largeCardQueueElement)
  );

  fullRowCardsQueue = [];

  parentElement.innerHTML = '';

  arrangedCards.forEach(card => {
    parentElement.appendChild(card);
  });
};
